// extracted by mini-css-extract-plugin
module.exports = {"content":"AppPage_content__--2Lh","panel":"AppPage_panel__n4jIn"};